import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { map, get, isEmpty, size, head } from 'lodash';
import { Main } from 'base-components';
import { MediaListener } from '../../utils';
import Filters from './Filters';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import GET_CATEGORIES_HALL from '../../../queries/GET_CATEGORIES_HALL';
import { Query } from '../../graphql';
import ParentCategory from './ParentCategory';
import ModifyCategory from './ModifyCategory';
import { If } from '../../shared';
import { NotFound, HasPermissions } from '../../common';

const Categories = ({ session }) => {
    const userSalesChannel = get(session, 'salesChannels', null);
    const salesChannelValue = size(userSalesChannel) === 1 ? get(head(userSalesChannel), 'store') : null;
    const [salesChannel, setSalesChannel] = useState(salesChannelValue);
    const [editModal, setEditModal] = useState({ visible: false });
    const [categoryOption, setCategoryOption] = useState(null);
    const [hall, setHall] = useState(null);
    const [pageReload, setPageReload] = useState(false);
    let queryVariables = {
        action: 'search',
        params: {
            id: get(categoryOption, 'value', null),
            salesChannel,
            hall
        }
    };
    const [variables, setVariables] = useState(queryVariables);
    const onClickSearch = () => setVariables(queryVariables);

    useEffect(() => {
        setPageReload(true);
        if (size(userSalesChannel) === 1) {
            queryVariables.params.salesChannel = salesChannelValue;
            onClickSearch();
        }
        setTimeout(() => setPageReload(false), 20);
    }, [session]);

    const initialLoad = !get(variables, 'params.salesChannel');

    return (
        <HasPermissions
            to={['categories-page:view']}
            otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
        >
            <Main background='#f4f4f4' withFooter>
                <MediaListener value={['18%', '100%', '100%']}>
                    {({ currentValue }) => (
                        <>
                            <HasPermissions
                                to={['categories-page:filter&search']}
                            >
                                { !pageReload && <Filters
                                    uniqueSalesChannel={size(userSalesChannel) === 1}
                                    currentValue={currentValue}
                                    categoryOption={categoryOption}
                                    onChangeCategories={setCategoryOption}
                                    onChangeSalesChannel={setSalesChannel}
                                    hall={hall}
                                    onChangeHall={setHall}
                                    searchDisabled={!salesChannel}
                                    onClickSearch={onClickSearch}
                                /> }
                            </HasPermissions>
                            <FlexContainer mT={20} direction='column' flex={1}>
                                <Query
                                    query={GET_CATEGORIES_HALL}
                                    variables={variables}
                                    skip={initialLoad}
                                >
                                    {({ data, loading }) => {
                                        const parentCategories = get(data, 'getCategories.data', []);
                                        if (initialLoad) {
                                            return (
                                                <NotFound
                                                    firstTextLine='Aún no se ha realizado una búsqueda, utiliza los filtros.'
                                                    icon='find'
                                                    iconBackgroundColor='#FFFFFF'
                                                    iconColor='#c0c0c0'
                                                    iconSize={85}
                                                    fontSize={20}
                                                />
                                            );
                                        }
                                        return (
                                            <If
                                                condition={!isEmpty(parentCategories)}
                                                then={map(parentCategories, ({ id, name, childrens }) => (
                                                    <ParentCategory
                                                        key={id}
                                                        id={id}
                                                        name={name}
                                                        childrens={childrens}
                                                        onClickEdit={({ categoryChildrenId, hall }) => setEditModal({ visible: true, categoryId: id, categoryChildrenId, hall })}
                                                    />
                                                ))}
                                                else={!loading && <NotFound firstTextLine='No se encontraron resultados' icon='cross' iconBackgroundColor='#eaeaea' />}
                                            />
                                        );
                                    }}
                                </Query>
                                { get(editModal, 'visible', false) && <ModifyCategory
                                    editModal={{ salesChannel: get(queryVariables, 'params.salesChannel'), ...editModal }}
                                    setEditModal={setEditModal}
                                /> }
                            </FlexContainer>
                        </>
                    )}
                </MediaListener>
            </Main>
        </HasPermissions>
        
    );
};

Categories.propTypes = {
    session: object
};

export default Categories;
